import { useEffect, useState } from 'react';

/**
 * Turns a file blob into an object URL for inline rendering (e.g.
 * `<object type="application/pdf">`), revoked when the blob changes or on unmount.
 */
export function usePdfObjectUrl(blob?: Promise<Blob>): string | undefined {
  const [objectUrl, setObjectUrl] = useState<string>();

  useEffect(() => {
    let revoked = false;
    let url: string | undefined;

    if (blob) {
      blob
        .then((resolved) => {
          // The effect may already have been cleaned up while the blob was
          // pending; creating the URL then would leak it.
          if (!revoked) {
            url = URL.createObjectURL(resolved);
            setObjectUrl(url);
          }
        })
        .catch(() => {
          // A stale rejection must not clear the URL of a newer blob.
          if (!revoked) {
            setObjectUrl(undefined);
          }
        });
    } else {
      setObjectUrl(undefined);
    }

    return () => {
      revoked = true;
      if (url) {
        URL.revokeObjectURL(url);
      }
      setObjectUrl(undefined);
    };
  }, [blob]);

  return objectUrl;
}
